// extracted by mini-css-extract-plugin
export default {"truncate":"TruncatedText_truncate__b-EHa"};